export default {
      id: "location-usage",
      viewBox: "0 0 15 22",
      url: __webpack_public_path__ + "sprite.svg#location",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./static/images/sprite-icons/location.svg
// module id = mi/v
// module chunks = 1